// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import AuthService from "./authService";
// import Navbar from "../Misc/Navbar";
// import { Link } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
// import log_in from "../../Assets/login.png";
// import "../Authentication/login.component.css"; // Import the CSS file

// export default function Login() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     role: "",
//   });

//   const [showPassword, setShowPassword] = useState(false); // State for password visibility

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleLogin = (event) => {
//     event.preventDefault();

//     const loginData = {
//       email: formData.email,
//       password: formData.password,
//     };

//     AuthService.login(loginData.email, loginData.password);

//     axios
//       .post("https://raasbackend.vetrinahealthcare.com/Login_view/", loginData)
//       .then((response) => {
//         const { user, message, error_message } = response.data;

//         if (error_message) {
//           Swal.fire({
//             icon: "error",
//             title: "Login Error",
//             text: error_message,
//             timer: 4000,
//             timerProgressBar: true,
//             showCancelButton: false,
//           });
//         } else if (user) {
//           const { role } = user;
//           const userName = user.name;
//           const userId = user.id;
//           localStorage.setItem("User_Role", role);
//           localStorage.setItem("UserName", userName);
//           localStorage.setItem("user_id", userId);
//           localStorage.setItem("email", formData.email);
//           Swal.fire({
//             icon: "success",
//             title: "Login Successful!",
//             text: message || "Welcome!",
//             timer: 1000,
//             timerProgressBar: true,
//             showConfirmButton: false,
//           }).then(() => {
//             if (role === "Admin") {
//               navigate("/Admindashboard");
//             } else if (role === "Candidate") {
//               navigate("/dashboard");
//             } else if (role === "Interviewer") {
//               navigate("/InterviewerDashboard");
//             } else if (role === "HR") {
//               navigate("/HRDashboard");
//             }
//           });
//         }
//       })
//       .catch((error) => {
//         if (error.response.status === 403) {
//           Swal.fire({
//             title: "Login Error",
//             html: '<span style="color: red;">Your account is inactive. Please contact the administrator.</span>',
//             icon: "warning",
//             timer: 5000,
//             timerProgressBar: true,
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Login Error",
//             text: "Invalid email or password. Please try again.",
//             timer: 4000,
//             timerProgressBar: true,
//           });
//         }
//       });
//   };

//   return (
//     <div className="fullscreen-background">
//       <Navbar />
//       <div className="form-wrapper">
//         <div className="signupLogin-box">
//           <form onSubmit={handleLogin}>
//             <h3 className="form-title">Sign In</h3>

//             <div className="input-container mb-3">
//               <div className="icon-container">
//                 <i className="fa-solid fa-user"></i>
//               </div>
//               <input
//                 type="email"
//                 autoComplete="off"
//                 className="email-input"
//                 required
//                 placeholder="Enter Email"
//                 name="email"
//                 onChange={handleInputChange}
//                 value={formData.email}
//               />
//             </div>

//             <div className="input-container">
//               <div className="icon-container">
//                 <i className="fa-solid fa-lock"></i>
//               </div>
//               <input
//                 type={showPassword ? "text" : "password"} // Toggle between text and password
//                 className="email-input"
//                 required
//                 placeholder="Enter Password"
//                 name="password"
//                 onChange={handleInputChange}
//                 value={formData.password}
//               />
//               {/* Eye icon to toggle password visibility */}
//               <div
//                 className="eye-icon"
//                 onClick={() => setShowPassword(!showPassword)} // Toggle visibility on click
//                 style={{
//                   cursor: "pointer",
//                   position: "absolute",
//                   right: "30px",
//                   top: "10px",
//                   fontSize: "25px", // Adjust icon size if needed
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Show or hide icon */}
//               </div>
//             </div>

//             <div className="mb-3 d-flex flex-column align-items-start">
//               <div className="custom-control custom-checkbox">
//                 <input
//                   type="checkbox"
//                   className="custom-control-input"
//                   id="customCheck1"
//                 />
//                 <label className="custom-control-label" htmlFor="customCheck1">
//                   Remember me
//                 </label>
//               </div>
//             </div>

//             <div className="d-grid">
//               <button type="submit" className="btn-shiny2" style={{ margin: "auto auto" }}>
//                 LOGIN
//               </button>
//             </div>

//             <p className="forgot-password text-center">
//               Forgot{" "}
//               <Link to="/forgotPass" style={{ color: "grey" }}>
//                 password?
//               </Link>
//             </p>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import AuthService from "./authService";
// import Navbar from "../Misc/Navbar";
// import { Link } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import "../Authentication/login.component.css";

// export default function Login() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     role: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleLogin = (event) => {
//     event.preventDefault();
//     setLoading(true);

//     const loginData = {
//       email: formData.email,
//       password: formData.password,
//     };

//     AuthService.login(loginData.email, loginData.password);

//     axios
//       .post("https://raasbackend.vetrinahealthcare.com/Login_view/", loginData)
//       .then((response) => {
//         const { user, message, error_message } = response.data;

//         if (error_message) {
//           Swal.fire({
//             icon: "error",
//             title: "Login Error",
//             text: error_message,
//             timer: 4000,
//             timerProgressBar: true,
//           });
//         } else if (user) {
//           const { role } = user;
//           const userName = user.name;
//           const userId = user.id;
//           localStorage.setItem("User_Role", role);
//           localStorage.setItem("UserName", userName);
//           localStorage.setItem("user_id", userId);
//           localStorage.setItem("email", formData.email);
//           Swal.fire({
//             icon: "success",
//             title: "Login Successful!",
//             text: message || "Welcome!",
//             timer: 1000,
//             timerProgressBar: true,
//             showConfirmButton: false,
//           }).then(() => {
//             if (role === "Admin") {
//               navigate("/Admindashboard");
//             } else if (role === "Candidate") {
//               navigate("/dashboard");
//             } else if (role === "Interviewer") {
//               navigate("/InterviewerDashboard");
//             } else if (role === "HR") {
//               navigate("/HRDashboard");
//             }
//           });
//         }
//       })
//       .catch((error) => {
//         if (error.response?.status === 403) {
//           Swal.fire({
//             title: "Login Error",
//             html: '<span style="color: red;">Your account is inactive. Please contact the administrator.</span>',
//             icon: "warning",
//             timer: 5000,
//             timerProgressBar: true,
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Login Error",
//             text: "Invalid email or password. Please try again.",
//             timer: 4000,
//             timerProgressBar: true,
//           });
//         }
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   return (
//     <div className="fullscreen-background">
//       <Navbar />
//       <div className="form-wrapper">

//         {/* TOP TEXT - ABOVE SIGN-IN BOX */}
//         <div className="login-heading-outside">
//           Right Talent. Right Time. Real Results.
//         </div>

//         {/* SIGN-IN FORM BOX */}
//         <div className="signupLogin-box">
//           <form onSubmit={handleLogin}>
//             <h3 className="form-title">Sign In</h3>

//             <div className="input-container mb-3">
//               <div className="icon-container">
//                 <i className="fa-solid fa-user"></i>
//               </div>
//               <input
//                 type="email"
//                 autoComplete="off"
//                 className="email-input"
//                 required
//                 placeholder="Enter Email"
//                 name="email"
//                 onChange={handleInputChange}
//                 value={formData.email}
//               />
//             </div>

//             <div className="input-container">
//               <div className="icon-container">
//                 <i className="fa-solid fa-lock"></i>
//               </div>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 className="email-input"
//                 required
//                 placeholder="Enter Password"
//                 name="password"
//                 onChange={handleInputChange}
//                 value={formData.password}
//               />
//               <div
//                 className="eye-icon"
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   cursor: "pointer",
//                   position: "absolute",
//                   right: "30px",
//                   top: "10px",
//                   fontSize: "25px",
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </div>
//             </div>

//             <div
//               className="mb-3 d-flex flex-column align-items-start"
//               style={{ marginTop: "15px" }}
//             >
//               <div
//                 className="custom-control custom-checkbox d-flex align-items-center"
//                 style={{ padding: "10px" }}
//               >
//                 <input
//                   type="checkbox"
//                   className="custom-control-input"
//                   id="customCheck1"
//                   style={{ marginRight: "10px", transform: "scale(1.2)" }}
//                 />
//                 <label
//                   className="custom-control-label"
//                   htmlFor="customCheck1"
//                   style={{
//                     fontSize: "16px",
//                     fontWeight: "500",
//                     color: "#333",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Remember me
//                 </label>
//               </div>
//             </div>

//             <div className="d-grid">
//               <button
//                 type="submit"
//                 className="btn-shiny2"
//                 style={{ margin: "auto auto", position: "relative" }}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <span className="spinner-border spinner-border-sm"></span>
//                 ) : (
//                   "LOGIN"
//                 )}
//               </button>
//             </div>

//             <p className="forgot-password text-center">
//               Forgot{" "}
//               <Link to="/forgotPass" style={{ color: "grey" }}>
//                 password?
//               </Link>
//             </p>
//           </form>
//         </div>

//         {/* BOTTOM TEXT - BELOW SIGN-IN BOX */}
//         <p className="login-description-outside">
//           We connect organizations with skilled professionals precisely when
//           they’re needed most. Our integrated recruitment, training, and
//           development solutions ensure that you don’t just fill roles, you build
//           a workforce that delivers measurable outcomes.
//         </p>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate, Link } from "react-router-dom";
// import AuthService from "./authService"; // Assuming this path is correct
// import Navbar from "../Misc/Navbar";    // Assuming this path is correct
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import "../Authentication/login.component.css"; // Ensure this path is correct

// export default function Login() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     // role: "", // Role is typically determined by the backend based on email/user type
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleLogin = (event) => {
//     event.preventDefault();
//     setLoading(true);

//     const loginData = {
//       email: formData.email,
//       password: formData.password,
//     };

//     // Assuming AuthService.login does something like setting a local flag or token.
//     // The actual login validation and role determination should happen on the backend.
//     AuthService.login(loginData.email, loginData.password); 

//     axios
//       .post("https://raasbackend.vetrinahealthcare.com/Login_view/", loginData) // Ensure your backend URL is correct (e.g., port 8000 for Django)
//       .then((response) => {
//         const { user, message, error_message } = response.data;

//         if (error_message) {
//           Swal.fire({
//             icon: "error",
//             title: "Login Error",
//             text: error_message,
//             timer: 4000,
//             timerProgressBar: true,
//           });
//         } else if (user && user.role && user.name && user.id) { // Added more checks for user object
//           const { role, name, id } = user;
//           localStorage.setItem("User_Role", role);
//           localStorage.setItem("UserName", name);
//           localStorage.setItem("user_id", id);
//           localStorage.setItem("email", formData.email); // Storing form email is fine
          
//           Swal.fire({
//             icon: "success",
//             title: "Login Successful!",
//             text: message || `Welcome, ${name}!`,
//             timer: 1500, // Slightly longer for welcome
//             timerProgressBar: true,
//             showConfirmButton: false,
//           }).then(() => {
//             if (role === "Admin") navigate("/Admindashboard");
//             else if (role === "Candidate") navigate("/dashboard");
//             else if (role === "Interviewer") navigate("/InterviewerDashboard");
//             else if (role === "HR") navigate("/HRDashboard");
//             else navigate("/"); // Fallback redirect
//           });
//         } else {
//           // This case handles if backend response is 200 but user object is incomplete or missing
//            Swal.fire({
//             icon: "warning",
//             title: "Login Issue",
//             text: "Received an unexpected response from the server. Please try again.",
//             timer: 4000,
//             timerProgressBar: true,
//           });
//         }
//       })
//       .catch((error) => {
//         const backendSpecificError = error.response?.data?.error_message || error.response?.data?.detail;
//         if (backendSpecificError) {
//             Swal.fire({
//                 icon: "error",
//                 title: "Login Error",
//                 text: backendSpecificError,
//                 timer: 4000,
//                 timerProgressBar: true,
//             });
//         } else if (error.response?.status === 403) {
//           Swal.fire({
//             title: "Access Denied",
//             html: '<span style="color: red;">Your account is inactive or you do not have permission. Please contact the administrator.</span>',
//             icon: "warning",
//             timer: 5000,
//             timerProgressBar: true,
//           });
//         } else if (error.request) { // Network error or server not responding
//             Swal.fire({
//                 icon: "error",
//                 title: "Network Error",
//                 text: "Could not connect to the server. Please check your internet connection and try again.",
//                 timer: 4000,
//                 timerProgressBar: true,
//             });
//         }
//         else { // Generic error
//           Swal.fire({
//             icon: "error",
//             title: "Login Error",
//             text: "An unexpected error occurred. Please try again.",
//             timer: 4000,
//             timerProgressBar: true,
//           });
//         }
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   return (
//     <div className="login-page-container"> 
//       <Navbar />
//       <div className="fullscreen-background">
//         <div className="form-wrapper">
//           <div className="login-heading-outside">
//             Right Talent. Right Time. Real Results.
//           </div>

//           <div className="signupLogin-box">
//             <form onSubmit={handleLogin}>
//               <h3 className="form-title">Sign In</h3>

//               <div className="input-container">
//                 <div className="icon-container">
//                   <i className="fa-solid fa-user"></i>
//                 </div>
//                 <input
//                   type="email"
//                   autoComplete="username" /* More appropriate for email */
//                   className="email-input"
//                   required
//                   placeholder="Enter Email"
//                   name="email"
//                   onChange={handleInputChange}
//                   value={formData.email}
//                 />
//               </div>

//               <div className="input-container">
//                 <div className="icon-container">
//                   <i className="fa-solid fa-lock"></i>
//                 </div>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   className="email-input"
//                   autoComplete="current-password" /* Helps password managers */
//                   required
//                   placeholder="Enter Password"
//                   name="password"
//                   onChange={handleInputChange}
//                   value={formData.password}
//                 />
//                 <div
//                   className="eye-icon"
//                   onClick={() => setShowPassword(!showPassword)}
//                   role="button" // Accessibility
//                   tabIndex={0} // Accessibility
//                   onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowPassword(!showPassword);}} // Accessibility
//                   aria-pressed={showPassword}
//                   aria-label={showPassword ? "Hide password" : "Show password"}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </div>
//               </div>

//               <div className="login-options">
//                 <div className="custom-control custom-checkbox">
//                   <input
//                     type="checkbox"
//                     className="custom-control-input"
//                     id="customCheck1"
//                   />
//                   <label
//                     className="custom-control-label"
//                     htmlFor="customCheck1"
//                   >
//                     Remember me
//                   </label>
//                 </div>
//                 <p className="forgot-password m-0"> {/* m-0 to remove default margin from <p> */}
//                   <Link to="/forgotPass">
//                     Forgot password?
//                   </Link>
//                 </p>
//               </div>

//               <div className="d-grid mt-3"> {/* d-grid might not be needed if btn-shiny2 is styled for width:100% */}
//                 <button
//                   type="submit"
//                   className="btn-shiny2"
//                   disabled={loading}
//                 >
//                   {loading ? (
//                     <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                   ) : (
//                     "LOGIN"
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>

//           <p className="login-description-outside">
//             We connect organizations with skilled professionals precisely when
//             they’re needed most. Our integrated recruitment, training, and
//             development solutions ensure that you don’t just fill roles, you build
//             a workforce that delivers measurable outcomes.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }





import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import AuthService from "./authService"; // Assuming this path is correct
import Navbar from "../Misc/Navbar";    // Assuming this path is correct
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../Authentication/login.component.css"; // Ensure this path is correct

export default function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleLogin = (event) => {
    event.preventDefault();
    setLoading(true);

    const loginData = {
      email: formData.email,
      password: formData.password,
    };

    AuthService.login(loginData.email, loginData.password); 

    axios
      .post("https://raasbackend.vetrinahealthcare.com/Login_view/", loginData)
      .then((response) => {
        const { user, message, error_message } = response.data;

        if (error_message) {
          Swal.fire({
            icon: "error",
            title: "Login Error",
            text: error_message,
            timer: 4000,
            timerProgressBar: true,
          });
        } else if (user && user.role && user.name && user.id) {
          const { role, name, id } = user;
          localStorage.setItem("User_Role", role);
          localStorage.setItem("UserName", name);
          localStorage.setItem("user_id", id);
          localStorage.setItem("email", formData.email);
          
          Swal.fire({
            icon: "success",
            title: "Login Successful!",
            text: message || `Welcome, ${name}!`,
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then(() => {
            if (role === "Admin") navigate("/Admindashboard");
            else if (role === "Candidate") navigate("/dashboard");
            else if (role === "Interviewer") navigate("/InterviewerDashboard");
            else if (role === "HR") navigate("/HRDashboard");
            else navigate("/");
          });
        } else {
           Swal.fire({
            icon: "warning",
            title: "Login Issue",
            text: "Received an unexpected response from the server. Please try again.",
            timer: 4000,
            timerProgressBar: true,
          });
        }
      })
      .catch((error) => {
        const backendSpecificError = error.response?.data?.error_message || error.response?.data?.detail;
        if (backendSpecificError) {
            Swal.fire({
                icon: "error",
                title: "Login Error",
                text: backendSpecificError,
                timer: 4000,
                timerProgressBar: true,
            });
        } else if (error.response?.status === 403) {
          Swal.fire({
            title: "Access Denied",
            html: '<span style="color: red;">Your account is inactive or you do not have permission. Please contact the administrator.</span>',
            icon: "warning",
            timer: 5000,
            timerProgressBar: true,
          });
        } else if (error.request) {
            Swal.fire({
                icon: "error",
                title: "Network Error",
                text: "Could not connect to the server. Please check your internet connection and try again.",
                timer: 4000,
                timerProgressBar: true,
            });
        }
        else {
          Swal.fire({
            icon: "error",
            title: "Login Error",
            text: "An unexpected error occurred. Please try again.",
            timer: 4000,
            timerProgressBar: true,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="login-page-container"> 
      <Navbar />
      <div className="fullscreen-background">
        <div className="form-wrapper">
          <div className="login-heading-outside">
            Right Talent. Right Time. Real Results.
          </div>

          <div className="signupLogin-box">
            <form onSubmit={handleLogin}>
              <h3 className="form-title">Sign In</h3>

              <div className="input-container">
                <div className="icon-container">
                  <i className="fa-solid fa-user" style={{ color: "purple" }}></i>

                </div>
                <input
                  type="email"
                  autoComplete="username"
                  className="email-input"
                  required
                  placeholder="Enter Email"
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                />
              </div>

              <div className="input-container">
                <div className="icon-container">
                  <i className="fa-solid fa-lock" style={{ color: "purple" }}></i>

                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  className="email-input"
                  autoComplete="current-password"
                  required
                  placeholder="Enter Password"
                  name="password"
                  onChange={handleInputChange}
                  value={formData.password}
                />
                <div
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowPassword(!showPassword);}}
                  aria-pressed={showPassword}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>

              <div className="login-options">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheck1"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheck1"
                  >
                    Remember me
                  </label>
                </div>
                <p className="forgot-password m-0">
                  <Link to="/forgotPass">
                    Forgot password?
                  </Link>
                </p>
              </div>

              <div className="d-grid mt-3">
                <button
                  type="submit"
                  className="btn-shiny2"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    "LOGIN"
                  )}
                </button>
              </div>
            </form>
          </div>

          <p className="login-description-outside">
            We connect organizations with skilled professionals precisely when
            they’re needed most. Our integrated recruitment, training, and
            development solutions ensure that you don’t just fill roles, you build
            a workforce that delivers measurable outcomes.
          </p>
        </div>
      </div>
    </div>
  );
}